import "./App.css";

function App() {
  return <div id="root-content"></div>;
}

export default App;
